import AddReminderModal from './AddReminderModal';

export default AddReminderModal;
